export default __webpack_public_path__ + "static/bg-wires-dd1fad81bca7f0f17de2135145f9ff8f.webp";